module.exports = __webpack_public_path__ + "static/media/s_cur_01.9ef261e2.png";